module.exports = __webpack_public_path__ + "img/user.36a5f521.png";